export type TodoSource = {conversation_id:string;conversation_title:string;created_at:string;sender:{id:string;name:string;avatar_key:string|null}|null};
export type TodoItem = {
  id: string; scope: 'personal' | 'conversation'; owner_user_id: string | null;
  conversation_id: string | null; source_conversation_id: string | null; source_message_id: string | null;
  conversation_title?:string|null; source?:TodoSource|null; membership_epoch_id?:string; read_only?:boolean;
  body: string; version: number; created_by_user_id: string; created_by_name: string | null;
  completed_at: string | null; completed_by_user_id: string | null; completed_by_name: string | null;
  created_at: string; updated_at: string;
};
export type TodoSummary = {total:number;completed:number};
export type TodoPage = {
  items: TodoItem[]; next_cursor: string | null; has_more: boolean;
  membership_epoch_id: string | null; read_only: boolean; summary?:TodoSummary;
};
export function parseTodoCommand(text: string): {kind: 'open'} | {kind: 'create'; text: string} | null {
  const value = text.trim();
  if (/^\/todo$/i.test(value)) return {kind:'open'};
  const prefix = /^\/todo\s*\|/i.exec(value);
  return prefix ? {kind:'create',text:value.slice(prefix[0].length).trim()} : null;
}
